/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconSatellite3 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M11.266 15.23a3.75 3.75 0 1 1 3.75-3.75l-3.75 3.75zM14.978 3.319L17.1 1.197a1.5 1.5 0 0 1 2.121 0l2.121 2.121a1.5 1.5 0 0 1 0 2.121L19.221 7.56a1.5 1.5 0 0 1-2.121 0l-2.122-2.12a1.501 1.501 0 0 1 0-2.121zM1.189 17.314l2.121-2.121a1.5 1.5 0 0 1 2.121 0l2.121 2.121a1.5 1.5 0 0 1 0 2.121l-2.121 2.121a1.5 1.5 0 0 1-2.121 0l-2.121-2.121a1.5 1.5 0 0 1 0-2.121zM7.023 7.237l1.591 1.591M16.969 13.763a5.265 5.265 0 0 1-3.188 3.194M20.15 13.413a8.256 8.256 0 0 1-6.729 6.728M23.25 12.664A11.25 11.25 0 0 1 12.5 23.25" />
      </g>
    </svg>
  ),
);
